import React from "react";

const WhatsAppButton = () => {
  const phoneNumber = "7416116587 ";
  const message = "Hii, Enquire from ANS Safety Nets website";
  const handleClick = () => {
    const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(
      message
    )}`;
    window.open(url, "_blank");
  };

  return (
    <div
      style={styles.button}
      onClick={handleClick}
      aria-label="Chat with us on WhatsApp"
    >
      <img
        src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
        loading="lazy"
        alt="ANS SAFETY NETS ,safety nets in bengaluru,"
        tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
Children Safety Nets,
Industrial Safety Nets,
Pets Safety Nets,
Ducteria Nets,
Monkey Safety Nets,
Cricket Practice Nets,
Bird Spikes"
        style={styles.icon}
      />
    </div>
  );
};

const styles = {
  button: {
    position: "fixed",

    bottom: "100px",
    right: "10px",

    cursor: "pointer",

    zIndex: "100000",
  },
  icon: {
    width: "50px",
    height: "50px",
  },
};

export default WhatsAppButton;
